// extracted by mini-css-extract-plugin
export default {"main_css_us":"InputNumberGroup_main_css_us__DC6C6","main_css_jp":"InputNumberGroup_main_css_jp__oQwPq"};